import { useDispatch } from "react-redux";
import { GetTotal, decreaseItemQTY, increaseItemQTY, removeFromCart } from "../ReduxToolKit/cartSlice";
import { useEffect } from "react";

const CartItem = ({ data }) => { 
  const { id, title, img, color, shadow, price, text, cartQty } = data;
  const dispatch = useDispatch()
  useEffect(()=>{
    dispatch(GetTotal())
  },[])
  return (
    <>
      <div className="flex justify-between items-center">
        <div className="product-container flex gap-2">
          <div className={`${shadow} bg-gradient-to-b rounded-md ${color} w-[150px]`}>
            <img src={img} alt={id} />
          </div>
          <div className="text">
            <p className="text-black text-[13px] font-semibold leading-3">{title}</p>
            <p className="text-black text-[12px]">{text}</p>
            <div className="btns flex justify-center gap-5 mt-2">
              <button className="cursor-pointer w-[20px] h-[20px] rounded-[4px] font-bold bg-black text-white text-[16px] text-center leading-[20px]" onClick={()=>dispatch( decreaseItemQTY(id))}>-</button>
              <button className="cursor-pointer w-[20px] h-[20px] rounded-[4px] font-bold bg-black text-white text-[12px]">{cartQty}</button>
              <button className="cursor-pointer w-[20px] h-[20px] rounded-[4px] font-bold bg-black text-white text-[16px] text-center leading-[20px]" onClick={()=>dispatch(increaseItemQTY(id))}>+</button>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center gap-2">
          <p className="text-black text-[12px] md:text-[14px] font-semibold">${price}</p>
          <div onClick={()=>dispatch(removeFromCart(id))}><i className="fas fa-trash cursor-pointer p-2 rounded-[4px] font-bold bg-black text-white text-[12px]"></i></div>
        </div>

      </div>
    </>
  )
}
export default CartItem;